import React, { useEffect, useState } from 'react';
import api from '../api';
import {
  Badge,
  Muted,
  Page,
  PageHeader,
  PageHeaderMain,
  PanelGrid,
  StatCard,
  StatValue,
  Subtitle,
  Surface,
  SurfaceBody,
  SurfaceHeader,
  SurfaceTitle,
  Title,
} from '../components/ui';

interface BotStatus {
  connected: boolean;
  channel: string | null;
  username: string | null;
}

const DashboardPage: React.FC = () => {
  const [status, setStatus] = useState<BotStatus | null>(null);
  const [stats, setStats] = useState({ users: 0, cards: 0, commands: 0 });

  useEffect(() => {
    const load = async () => {
      const [botRes, usersRes, cardsRes, commandsRes] = await Promise.all([
        api.get('/config/bot-status'),
        api.get('/users?limit=1'),
        api.get('/cards'),
        api.get('/commands'),
      ]);
      setStatus(botRes.data);
      setStats({
        users: usersRes.data.total || 0,
        cards: cardsRes.data.length || 0,
        commands: commandsRes.data.filter((c: { active: boolean }) => c.active).length || 0,
      });
    };
    load();
  }, []);

  return (
    <Page>
      <PageHeader>
        <PageHeaderMain>
          <Title>Dashboard</Title>
          <Subtitle>Estado del bot y resumen del sistema.</Subtitle>
        </PageHeaderMain>
      </PageHeader>

      <PanelGrid $cols="repeat(3, minmax(0, 1fr))">
        <StatCard>
          <Muted style={{ margin: 0, fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.4px' }}>Usuarios</Muted>
          <StatValue>{stats.users}</StatValue>
        </StatCard>
        <StatCard>
          <Muted style={{ margin: 0, fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.4px' }}>Cartas</Muted>
          <StatValue>{stats.cards}</StatValue>
        </StatCard>
        <StatCard>
          <Muted style={{ margin: 0, fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.4px' }}>Comandos activos</Muted>
          <StatValue>{stats.commands}</StatValue>
        </StatCard>
      </PanelGrid>

      <Surface>
        <SurfaceHeader>
          <SurfaceTitle>Bot Twitch</SurfaceTitle>
          <Badge $active={!!status?.connected}>{status?.connected ? 'Conectado' : 'Desconectado'}</Badge>
        </SurfaceHeader>
        <SurfaceBody>
          <PanelGrid $cols="repeat(2, minmax(0, 1fr))">
            <div>
              <Muted style={{ margin: 0 }}>Canal</Muted>
              <p style={{ margin: '0.25rem 0 0', color: '#fff', fontSize: '0.95rem' }}>{status?.channel || '—'}</p>
            </div>
            <div>
              <Muted style={{ margin: 0 }}>Usuario bot</Muted>
              <p style={{ margin: '0.25rem 0 0', color: '#fff', fontSize: '0.95rem' }}>{status?.username || '—'}</p>
            </div>
          </PanelGrid>
        </SurfaceBody>
      </Surface>
    </Page>
  );
};

export default DashboardPage;
